import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

const DISCLAIMER = 'AI-generated summary based on information from our website and the internet';

/**
 * The AI attribution line that sits under a summary, shared by every banner variant.
 *
 * The design's "Body/Extra Small/tight line height" in Text/Primary: `body-xs` is 12px, `tight` is
 * the 125% line height, and `primary` is the specified #202020 — not the muted grey this kind of
 * line usually takes. Together those give the 15px line box the design measures.
 */
export const AiDisclaimer = ({ align = 'trailing' }) => {
  return (
    <div className={align === 'trailing' ? 'sui-text-left lg:sui-text-right' : 'sui-text-left'}>
      <Typography variant="body-xs" color="primary" height="tight">
        {DISCLAIMER}
      </Typography>
    </div>
  );
};

AiDisclaimer.displayName = 'AiDisclaimer';

AiDisclaimer.propTypes = {
  /**
   * `trailing` when it follows a summary alongside other content, so it aligns right on desktop and
   * left once stacked. `start` when it is its own row and always reads from the left.
   */
  align: PropTypes.oneOf(['trailing', 'start']),
};
